import { redirect } from "react-router-dom";
import { logoutRdx } from "../../../store/redux_auth/authSlice";
import { store } from "../../../store";
import { ApiClient } from "../../../api/ApiClient";
import { triggerNativeLogoutIfAvailable } from "../../../utils/native/nativeLogout";

export async function action() {
  const apiBaseUrl = process.env.REACT_APP_API_DOMAIN;

  // Fire-and-forget; must never delay or block logout.
  triggerNativeLogoutIfAvailable();

  try {
    // Try to get CSRF token, but don't fail if it's expired (401)
    const csrfToken = await ApiClient.getCsrfToken(true);

    // Attempt logout with or without CSRF token
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      
      if (csrfToken) {
        headers["X-CSRFToken"] = csrfToken;
      }

      await fetch(`${apiBaseUrl}/auth/logout`, {
        method: "POST",
        headers,
        credentials: "include",
      });
    } catch (error) {
      // Logout request failed, but we'll still clean up locally
      console.warn("Logout request failed, proceeding with local cleanup:", error.message);
    }
  } catch (error) {
    console.error("Logout process failed:", error);
  }

  // After backend logout succeeded, clean up Redux state
  store.dispatch(logoutRdx());
  
  // Redirect to home page (no page reload needed, RootApp uses Redux state)
  return redirect("/");
}
